<template>
  <div>
    <div v-if="!isPC" class="mobile-index">
      <!-- 登录 -->
      <div v-if="!$store.state.common.userId && loginTop" class="login-top f-b-c">
        <div>{{ $t('Index.Index.LoginExperience') }}</div>
        <div class="f--c">
          <el-button type="primary" @click="$router.push({path:'/login'})">{{$t('headerBar.login')}}</el-button>
          <div class="login-close f-c-c" @click="loginTop = false"><i class="iconfont icon-a-close-line1"></i></div>
        </div>
      </div>
      <search-bar @search="searchHandle" />
      <!-- <div v-if="!$store.state.common.userId" class="login-box">
        <div class="text">Please log in so that we can provide you with products and services</div>
        <div class="btn f-b-c">
          <div class="f-c-c" @click="$router.push({path:'/register'})">Register</div>
          <div class="login f-c-c" @click="$router.push({path:'/login'})">{{$t('headerBar.login')}}</div>
        </div>
      </div> -->
      <!-- 轮播图 -->
      <div class="banner">
        <div class="swiper-container">
          <div class="swiper-wrapper">
            <template v-for="(item, i) in bannerList">
              <div :key="'banner'+i" class="swiper-slide banner-box" :class="{ pointer: item.path }" @click="bannerJump(item)">
                <oss-img :src="item.url" :width="700" :height="225" />
              </div>
            </template>
          </div>
        </div>
      </div>
      <!-- 特色专区 -->
      <div class="special-column">
        <div class="special-column-left pointer" @click="jump(customColumn.path, 'specialCustomization', $t(customColumn.title))">
            <div class="special-column-item">
                <div class="title">{{ $t(customColumn.title) }}</div>
                <div class="subhead ellipsis" v-for="(t, i) in customColumn.subhead" :key="'customColumn'+i">{{ $t(t) }}</div>
            </div>
          </div>

          <div class="special-column-right pointer" @click="jump(similarColumn.path, 'specialFashion', $t(similarColumn.title))">
            <div class="special-column-item">
                <div class="title">{{ $t(similarColumn.title) }}</div>
                <div class="subhead ellipsis" v-for="(t, i) in similarColumn.subhead" :key="'similarColumn'+i">{{ $t(t) }}</div>
            </div>
          </div>
      </div>
      <!-- 折扣 -->
      <!-- 首页隐藏折扣商品 7.20 -->
      <!-- <div v-if="discount.length" class="discount f--c">
        <div v-for="(t, i) in discount" :key="i" class="item f-c-c pointer" @click="$router.push({ path: '/mall/discount', query: { discountId: t.discountId, type: t.type }})">
          <div class="f--c">
            <span class="rate" v-if="t.discountPercent">{{ t.discountPercent }}%</span>
            <span class="rate" v-if="!t.discountPercent && t.discountFixed">USD {{ t.discountFixed }}</span>
            <span class="unit f-c-c">OFF</span>
          </div>
          <div class="describe ellipsis2">{{ t.discountName }}</div>
        </div>
      </div> -->
      <!-- 限时抢购 秒杀 -->
      <div v-if="flashSale.length" class="flash-sale" style="background:#fff; padding: 16px; border-radius: 4px;">
        <div class="head f-b-c">
          <!-- <div class="title">{{$t('indexPage.flashSale')}}</div> -->
          <!-- <oss-img :src="'https://img.kakaclo.com/web-img/index/flash-sale-title.png'" :width="54" :height="16"></oss-img>
          <div class="f--c" @click="jumpFlashSale()">
            <Time :deadline="+saleEndTime" />
            <i class="iconfont icon-jiantou_xiangyouliangci" style="font-size:.4rem;margin-left:.08rem" />
          </div> -->
          <div>
            <span style="color: #303133; font-size: 24px; font-weight: 700; margin-right: 10px; font-style: italic;">Flash</span>
            <span style="color: #FB5053; font-size: 24px; font-weight: 700; font-style: italic;">Sale</span>
          </div>
          <div class="f--c pointer" @click="jumpFlashSale()">
            <span class="view-more">{{ $t('Index.Index.ViewMore') }}</span>
            <!-- <Time :deadline="+saleEndTime" />
            <i class="iconfont icon-jiantou_xiangyouliangci" style="font-size:24px;margin-left:10px" /> -->
          </div>
        </div>
        <div class="list f-b" style="justify-content: unset;">
            <div class="new-flash-sale">
              <div class="flash-sale-name">
                <div style="font-size: 18px;">FLASH</div>
                <div style="font-size: 24px; line-height: 24px;">SALE</div>
              </div>
              <div style="font-weight: 400; font-size: 10px; margin-top: 12px;">
                <span>{{ startTime }}</span>
                <span style="display: inline-block; padding: 0 8px;">-</span>
                <span>{{ endTime }}</span>
              </div>
              <div class="sale-view-more">
                <a  @click="jumpFlashSale()">View More</a>
              </div>
            </div>
            <Product v-for="item in saleProductList.slice(0, 2)" :key="item.kkProductId" :product="item" :isShowSalePrice="false" :isShowName="false" kklocation="mayLikeProduct" reportType="activity" style="width:32%; margin-left: 2%;"></Product>
          </div>
        </div>

        <!-- 专辑 首页展示 -->
        <template v-if="albumIndexList && albumIndexList.length">
          <div v-for="(item, i) in albumIndexList" :key="item.moduleId" class="flash-sale m-t-3">
            <div>
              <div class="head f-b-c">
                <div class="ellipsis" style="width: 65%;">
                  <oss-img v-if="item.mainUrl" :src="item.mainUrl" :width="180" :height="22"></oss-img>
                  <div v-else class="title ellipsis">{{ item.name }}</div>
                </div>
                <div class="f--c pointer" @click="jumpAlbum(item)">
                  <span class="view-more">{{ $t('Index.Index.ViewMore') }}</span>
                </div>
              </div>
              <div v-if="item.moduleList && item.moduleList.length" class="sale-list" style="display: flex;">
                <!-- <product-carousel :slideindex="i" :product-list="item.moduleList" kklocation="albumProduct" reportType="album" :moduleId="item.moduleId"/> -->
                <Product v-for="item in item.moduleList.slice(0, 3)" :number="i" :key="item.kkProductId" :product="item" :isShowSalePrice="false" :isShowName="false" kklocation="mayLikeProduct" reportType="activity" style="width:32%; margin-left: 2%;"></Product>
              </div>

            </div>
          </div>
        </template>

      <!-- 节日专区 -->
      <div v-for="item in festivalSaleList" :key="item.discountId" >
        <div  v-if="item.titleStatus" class="flash-sale">
          <div>
            <div class="head f-b-c">
              <oss-img :src="item.titleImgurl" :width="86" :height="11"></oss-img>
              <div class="f--c pointer" @click="jumpFestivalSale(item)">
                <span class="view-more">{{ $t('Index.Index.ViewMore') }}</span>
              </div>
            </div>
            <div v-if="item.list && item.list.length" class="sale-list">
              <div :style="{ width: (2*(item.list.length)+.26*(item.list.length-1)) + 'rem' }" class="f--c">
                <div v-for="t in item.list" :key="t.kkProductId" class="product">
                  <Product :product="t" kklocation="festivityProduct" reportType="activity" :isShowSalePrice="false" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 分类专区 -->
      <!-- <div class="clsss-column swiper-container">
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="(t, i) in clsssColumn" :key="i" style="padding-right:.5px">
            <class-column :column="t" kklocation="classifyProduct" style="border: .5px solid #F1F1F1;" />
          </div>
        </div>
        <div class="swiper-pagination"></div>
      </div> -->

      <div style="margin-top: 20px;;">
        <div class="clsss-column swiper-container" v-for="(t, i) in clsssColumn" :key="'clsssColumn'+i" >
          <div class="swiper-wrapper">
            <div class="swiper-slide" style="padding-right:.5px">
              <class-column :column="t" kklocation="classifyProduct" style="border: .5px solid #F1F1F1;" />
            </div>
          </div>
        </div>
      </div>

      <!-- <div class="clsss-column">
        <div v-for="(t, i) in clsssColumn" :key="i">
          <class-column :column="t" style="border: .5px solid #F1F1F1;" />
        </div>
      </div> -->
      <!-- 猜你喜欢 -->
      <div class="like">
        <div class="title">{{$t('headerBar.newIn')}}</div>
        <div class="list f-b" v-loading="listLoading">
          <Product style="margin-bottom: 20px;" v-for="item in likeProductList" :key="item.kkProductId" :product="item" :isShowSaleCount="true" :isShowSalePrice="false" kklocation="newProduct" reportType="recommend"></Product>
          <div class="empty-product"></div>
        </div>
        <div v-if="!showMore" style="text-align:center;padding:.3rem 0">{{ $t('Index.Index.NoRecommendedProduct') }}</div>
      </div>

      <div class="description">
        <h2 class="toggle-title">{{$t('Index.IndexPage.title')}}</h2>
        <i v-if="isExpanded" class="iconfont icon-07jiantouxiangshang toggle-button" @click="toggleDescription" />
        <i v-else class="iconfont icon-07jiantouxiangxia toggle-button" @click="toggleDescription" />
        <div :class="{'collapsed': !isExpanded}" class="description-text ellipsis2" :style="{ overflow: !isExpanded ? 'hidden' : 'auto', height: !isExpanded ? '40px' : 'unset', '-webkit-line-clamp':!isExpanded ? '2' : 'unset' }">
          <div v-html="$t('Index.IndexPage.description')"></div>
        </div>
      </div>
    </div>
    <div v-else class="index f--c">
      <div class="main">
        <div class="banner-contents f-b">
          <div class="contents1">
            <category />
          </div>
          <div class="banner">
            <!-- <el-carousel height="329px"> -->
            <el-carousel height="376px" @change="changeBanner">
              <el-carousel-item v-for="(item, i) in bannerList" :key="i">
                <div class="banner-box" :class="{ pointer: item.path }" @click="bannerJump(item)">
                  <oss-img :src="item.url" :width="1000" :height="376" :alt="item.bannerName"/>
                </div>
              </el-carousel-item>
            </el-carousel>
          </div>
          <div class="contents1">
            <category-right />
          </div>
        </div>
        <!-- <div class="cooperation f-c-c pointer" @click="jump('/personal-center/store-manage', 22, 'E-channels Integrated')">
          <div class="text">E-channels Integrated</div>
          <img src="@/assets/img/icon/store_logo1.svg" style="width:300px;height:24px" alt="">
          <div class="text" style="margin-left:40px">More will be integrated soon </div>
          <img src="@/assets/img/icon/store_logo2.svg" style="width:265px;height:24px" alt="">
        </div> -->

        <!-- 特色专区 -->
        <!-- <div class="special-column f-b-c m-t-3">
          <div class="pointer" @click="jump(customColumn.path, 'specialCustomization', $t(customColumn.title))">
            <special-column :column="customColumn" />
          </div>
          <div class="pointer" @click="jump(similarColumn.path, 'specialFashion', $t(similarColumn.title))">
            <special-column :column="similarColumn">
              <div class="img f-c-c" v-if="similarColumn.logo">
                <oss-img :src="similarColumn.logo" :width="180" :height="40" />
              </div>
            </special-column>
          </div>
        </div> -->

        <div class="special-column f-b-c m-t-3" style="margin: 24px 0 40px;">
          <div class="special-column-left pointer" @click="jump(customColumn.path, 'specialCustomization', $t(customColumn.title))">
            <div class="special-column-item">
                <div class="title">{{ $t(customColumn.title) }}</div>
                <div class="subhead ellipsis" v-for="(t, i) in customColumn.subhead" :key="i">{{ $t(t) }}</div>
            </div>
          </div>

          <div class="special-column-right pointer" @click="jump(similarColumn.path, 'specialFashion', $t(similarColumn.title))">
            <div class="special-column-item">
                <div class="title">{{ $t(similarColumn.title) }}</div>
                <div class="subhead ellipsis" v-for="(t, i) in similarColumn.subhead" :key="i">{{ $t(t) }}</div>
            </div>
          </div>
        </div>

        <!-- 限时抢购 -->
        <div v-if="flashSale.length && saleProductList && saleProductList.length" class="flash-sale m-t-3">
          <div class="head f-b-c">
            <!-- <div class="title">{{$t('indexPage.flashSale')}}</div> -->
            <!-- <oss-img :src="'https://hbo-shenzhen.oss-cn-shenzhen.aliyuncs.com/web-img/index/flash-sale-title.png'" :width="90" :height="22"></oss-img> -->
            <div>
              <span style="color: #303133; font-size: 24px; font-weight: 700; margin-right: 10px; font-style: italic;">Flash</span>
              <span style="color: #FB5053; font-size: 24px; font-weight: 700; font-style: italic;">Sale</span>
            </div>
            <div class="f--c pointer" @click="jumpFlashSale()">
              <span class="view-more">{{ $t('Index.Index.ViewMore') }}</span>
              <!-- <Time :deadline="+saleEndTime" />
              <i class="iconfont icon-jiantou_xiangyouliangci" style="font-size:24px;margin-left:10px" /> -->
            </div>
          </div>
          <div>
            <div class="list f-b" style="justify-content: unset;">
              <div class="new-flash-sale">
                <div class="flash-sale-name">
                  <div style="font-size: 36px;">FLASH</div>
                  <div style="font-size: 48px; line-height: 44px;">SALE</div>
                </div>
                <div style="font-weight: 400;">
                  <span>{{ startTime }}</span>
                  <span style="display: inline-block; padding: 0 8px;">-</span>
                  <span>{{ endTime }}</span>
                </div>
                <div class="sale-view-more">
                  <a  @click="jumpFlashSale()">{{ $t('Index.Index.ViewMore') }}</a>
                </div>
              </div>
              <Product v-for="item in saleProductList.slice(0, 5)" :key="item.kkProductId" :product="item" kklocation="mayLikeProduct" reportType="activity" style="width:15.7%; margin-left: 1%;"></Product>
            </div>
          </div>
        </div>

        <!-- 专辑 首页展示 -->
        <template v-for="(item, i) in albumIndexListLoop">
          <template v-if="item.moduleList && item.moduleList.length">
            <div :key="item.moduleId" :i="i" class="flash-sale m-t-3">
              <div>
                <div class="head f-b-c">
                  <div>
                    <oss-img v-if="item.mainUrl" :src="item.mainUrl" :width="180" :height="22"></oss-img>
                    <div v-else class="title">{{ item.name }}</div>
                  </div>
                  <div class="f--c pointer" @click="jumpAlbum(item)">
                    <span class="view-more">{{ $t('Index.Index.ViewMore') }}</span>
                    <!-- <i class="iconfont icon-jiantou_xiangyouliangci" style="font-size:24px;margin-left:10px" /> -->
                  </div>
                </div>
                <div v-if="item.moduleList && item.moduleList.length" class="sale-list">
                  <!-- <product-carousel :slideindex="i" :product-list="item.moduleList" kklocation="albumProduct" reportType="album" :moduleId="item.moduleId" /> -->
                  <product-carousel-loop :slideindex="i" :product-list="item.moduleList" kklocation="albumProduct" reportType="album" :moduleId="item.moduleId" />
                </div>
              </div>
            </div>
          </template>
        </template>

        <!-- 折扣 -->
        <!-- 首页隐藏折扣商品 7.20 -->
        <!-- <div v-if="discount.length" class="discount f--c m-t-3">
          <div v-for="(t, i) in discount" :key="i" class="item f-c-c pointer" @click="jumpDiscount(t)">
            <div class="f--c">
              <span class="rate" v-if="t.discountPercent">{{ t.discountPercent }}%</span>
              <span class="rate" v-if="!t.discountPercent && t.discountFixed">USD {{ t.discountFixed }}</span>
              <span class="unit f-c-c">OFF</span>
            </div>
            <div class="describe ellipsis2">{{ t.discountName }}</div>
          </div>
        </div> -->

        <!-- 节日特辑 -->
        <template v-for="(item, i) in festivalSaleList">
          <div v-if="item.titleStatus" :key="item.discountId" class="flash-sale m-t-3">
            <div>
              <div class="head f-b-c">
                <oss-img :src="item.titleImgurl" :width="180" :height="22"></oss-img>
                <div class="f--c pointer" @click="jumpFestivalSale(item)">
                  <span class="view-more">{{ $t('Index.Index.ViewMore') }}</span>
                  <!-- <i class="iconfont icon-jiantou_xiangyouliangci" style="font-size:24px;margin-left:10px" /> -->
                </div>
              </div>
              <div v-if="item.list && item.list.length" class="sale-list">
                <product-carousel :slideindex="albumIndexList.length?albumIndexList.length+i:i" :product-list="item.list" kklocation="festivityProduct" reportType="activity" :discountId="item.discountId" />
              </div>
            </div>
          </div>
        </template>

        <!-- 分类专区 -->
        <div class="clsss-column f-b-c m-t-3">
          <div v-for="(t, i) in clsssColumn" :key="i">
            <class-column :column="t" kklocation="classifyProduct" />
          </div>
          <template v-if="clsssColumn.length % 3 == 1">
            <div></div><div></div>
          </template>
          <template v-if="clsssColumn.length % 3 == 2"><div></div></template>
        </div>

        <!-- 猜你喜欢 -->
        <div class="like m-t-3" style="margin-top: 20px;">
          <div class="title">{{$t('headerBar.newIn')}}</div>
          <div class="list f-b" v-loading="listLoading">
            <Product v-for="item in likeProductList" :key="item.kkProductId" :product="item" kklocation="newProduct" reportType="recommend"></Product>
            <div v-for="i in 4" :key="i" class="empty-product"></div>
          </div>
          <!-- <el-button v-if="showMore" class="more f-c-c pointer" :loading="listLoading" @click="handleMore">
            <div>{{$t('indexPage.viewMore')}}</div>
            <i class="iconfont icon-jiantou-xuanze" />
          </el-button>
          <div v-else style="text-align:center;">{{ $t('Index.Index.NoRecommendedProduct') }}</div> -->
        </div>

        <div class="description">
          <h2 class="toggle-title">{{$t('Index.IndexPage.title')}}</h2>
          <i v-if="isExpanded" class="iconfont icon-07jiantouxiangshang toggle-button" @click="toggleDescription" />
          <i v-else class="iconfont icon-07jiantouxiangxia toggle-button" @click="toggleDescription" />
          <div :class="{'collapsed': !isExpanded}" class="description-text ellipsis2" :style="{ overflow: !isExpanded ? 'hidden' : 'auto', height: !isExpanded ? '40px' : 'unset', '-webkit-line-clamp':!isExpanded ? '2' : 'unset' }">
            <div v-html="$t('Index.IndexPage.description')"></div>
          </div>
        </div>
      </div>
    </div>
    <!-- 返回顶部 -->
    <el-backtop :bottom="190" :right="6" class="backtop">
      <img style="width:70px;height:70px" src="@/assets/img/homePage/backtop.png" alt="" />
    </el-backtop>

  </div>
</template>

<script>
import API from '@/api'
import Product from '@/components/Product.vue'
import Category from './components/Category.vue'
import CategoryRight from './components/CategoryRight.vue'
// import _ from 'lodash'
import ClassColumn from './components/ClassColumn.vue'
import SpecialColumn from './components/SpecialColumn.vue'

import Time from './components/Time.vue'
import ProductCarousel from '@/components/ProductCarousel.vue'
import ProductCarouselLoop from '@/components/ProductCarouselLoop.vue'
import OssImg from '../../components/OssImg.vue'
import SearchBar from '../../components/mobile/SearchBar.vue'
import Swiper from 'swiper'
import 'swiper/dist/css/swiper.min.css'
import { isInViewport } from '@/util/isInViewport'

export default {
  metaInfo: {
    title: 'Wholesale Clothing Suppliers - Affordable and Diverse Options in Bulk Apparel - KakaClo',
    meta: [
      {
        name: 'description',
        content: 'Our online boutique wholesale clothing store offers a wide range of fashionable clothing at wholesale prices. With a local wholesale market connection, we bring you the trendiest and hottest fashion pieces. Shop now and stock up your boutique with our wholesale fashion clothing.'
      }
    ]
  },
  components: {
    Category,
    CategoryRight,
    Product,
    ClassColumn,
    SpecialColumn,
    Time,
    ProductCarousel,
    ProductCarouselLoop,
    OssImg,
    SearchBar
  },
  provide() {
    return {
      productShowProgress: true
    }
  },
  data() {
    return {
      loginTop: true,
      // storeLogo: [
      //   { url: 'https://img.kakaclo.com/web-img/index/store_logo1.png', width: 87, height: 24 },
      //   { url: 'https://img.kakaclo.com/web-img/index/store_logo2.png', width: 92, height: 22 },
      //   { url: 'https://img.kakaclo.com/web-img/index/store_logo3.png', width: 93, height: 18 },
      //   { url: 'https://img.kakaclo.com/web-img/index/store_logo4.png', width: 105, height: 21 },
      //   { url: 'https://img.kakaclo.com/web-img/index/store_logo5.png', width: 34, height: 14 },
      //   { url: 'https://img.kakaclo.com/web-img/index/store_logo6.png', width: 68, height: 18 }
      // ],
      bannerList: [
        // { url: 'https://img.kakaclo.com/web-img/index/banner0.jpg', path: '' }
      ],
      discount: [], // 折扣活动
      flashSale: [], // 限时抢购
      saleEndTime: '', // 截止时间
      saleProductList: [], // 秒杀商品列表
      customColumn: {
        title: 'indexPage.customization',
        subhead: [
          'indexPage.customizationText1',
          'indexPage.customizationText2'
        ],
        logo: '',
        path: '/service',
        list: [
          { url: 'https://img.kakaclo.com/web-img/index/customization_1.png' },
          { url: 'https://img.kakaclo.com/web-img/index/customization_2.png' },
          { url: 'https://img.kakaclo.com/web-img/index/customization_3.png' }
        ]
      },
      similarColumn: {
        title: 'headerBar.fashionTrends',
        subhead: [
          'indexPage.insText1',
          'indexPage.insText2'
        ],
        logo: 'https://img.kakaclo.com/web-img/index/similar_logo.png',
        path: '/mall/explore',
        list: [
          { url: 'https://img.kakaclo.com/web-img/index/similar1.png' },
          { url: 'https://img.kakaclo.com/web-img/index/similar2.png' },
          { url: 'https://img.kakaclo.com/web-img/index/similar3.png' }
        ]
      },
      albumIndexList: [], // 首页专辑
      albumIndexListLoop: [], // 循环用到
      clsssColumn: [{}, {}, {}, {}], // 首页品类
      likeProductList: [],
      total: 0,
      likeParam: {
        pageNumber: 1,
        pageSize: 50
      },
      listLoading: false,
      showMore: true,
      website: [],
      festivalSaleList: [], // 节日促销
      holloweenProductList: [], // 万圣节节日促销商品
      christmasProductList: [], // 圣诞节节日促销商品
      isExpanded: false
    }
  },
  computed: {
    userId() {
      return this.$store.state.common.userId
    }
  },
  created() {
    // 轮播图
    this.getProductBanner()

    // 专辑首页展示
    this.getAlbumModuleIndexList()
    // 节日抢购
    this.getFestivalSaleList()
    // 限时抢购
    this.getFlashSaleList()
    // // 折扣活动
    // this.getDiscountList()

    // 首页品类
    this.getDynamicCategroy()
    // this.getAlbumModuleShow()
    // 猜你喜欢
    this.getIndexUserRecs()
  },
  mounted() {
    this.initSwiper()
    // this.$nextTick(() => {
    //   window.addEventListener('scroll', this.scroll)
    // })
  },
  beforeDestroy() {
    // window.removeEventListener('scroll', this.scroll)
  },
  methods: {
    initSwiper() {
      this.$nextTick(() => {
        new Swiper('.swiper-container', {
          autoplay: 3000,
          observer: true, // 修改swiper自己或子元素时，自动初始化swiper
          observeParents: true, // 修改swiper的父元素时，自动初始化swiper
          pagination: '.swiper-pagination'
        })
      })
    },

    // 切换轮播图
    changeBanner(e) {
      if (isInViewport(document.querySelectorAll('.banner-contents')[0]) && !document.hidden) {
        this.$record({
          eventType: 'exposure',
          eventId: `${this.$route.meta.pageId}_exposure`,
          value: JSON.stringify({ linkUrl: this.bannerList[e].linkUrl, imgUrl: this.bannerList[e].url, exposureLocation: `${this.$route.meta.pageId}_banner`, type: 'banner' })
        })
      }
    },

    // 前台展示banner
    getProductBanner() {
      const website = this.$store.state.website
      API.getProductBanner().then(({ data }) => {
        this.bannerList = data.map(item => {
          if (item.type !== 1) return undefined
          let url = website.filter(t => item.linkUrl && item.linkUrl.includes(t))
          let obj = {
            url: item.imgUrl,
            path: url.length ? item.linkUrl.split(url[0])[1] : item.linkUrl,
            linkUrl: item.linkUrl,
            bannerName: item.bannerName,
            type: item.type
          }
          return obj
        }).filter(Boolean)
      })
    },

    // 轮播跳转
    bannerJump(item) {
      let path = item.path
      if (path) {
        this.$record({
          eventType: 'click',
          eventId: `${this.$route.meta.pageId}_banner_click`,
          value: JSON.stringify({ linkUrl: item.linkUrl, imgUrl: item.url })
        })
        if (path.includes('https://') || path.includes('http://')) {
          window.open(path)
        } else if (path.includes('/content/')) {
          location.href = path
        } else {
          this.$router.push(path)
        }
      }
    },

    // 折扣活动
    getDiscountList() {
      API.getDiscountList({
        pageNumber: 1,
        pageSize: 3,
        type: 2,
        status: 1,
        sortType: 3
      }).then(({ data }) => {
        this.discount = data.list
      })
    },

    // 限时抢购
    getFlashSaleList() {
      API.getDiscountList({
        pageNumber: 1,
        pageSize: 3,
        type: 1,
        status: 1,
        sortType: 3
      }).then(({ data }) => {
        this.flashSale = data.list
        console.log(this.flashSale)
        if (data.list && data.list.length) {
          let endTime = new Date(data.list[0].endTime)
          this.endTime = (endTime.getMonth() + 1 < 10 ? '0' + (endTime.getMonth() + 1) : endTime.getMonth() + 1) + '.' + endTime.getDate()
          let startTime = new Date(data.list[0].startTime)
          this.startTime = (startTime.getMonth() + 1 < 10 ? '0' + (startTime.getMonth() + 1) : startTime.getMonth() + 1) + '.' + startTime.getDate()
          // this.saleEndTime = data.list[0].endTime
          this.getDiscountProductList(data.list[0].discountId)
        }
      })
    },

    getFestivalDiscountProductList(id, index) {
      API.getDiscountProductList({
        pageNumber: 1,
        pageSize: 10,
        discountId: id,
        type: 3 // 1-限时促销 2-折扣活动(默认1)
        // sortType: 1, // 1-降序（默认），2-升序
        // sortName: 1 // 1-上架时间、2-售价、3-销售数量、4-库存
      }).then(({ data }) => {
        this.festivalSaleList.forEach((item, i) => {
          if (index === i) this.$set(item, 'list', data.list)
        })
      })
    },

    // 节日折扣产品
    getFestivalSaleList() {
      API.getDiscountList({
        pageNumber: 1,
        pageSize: 3,
        type: 3,
        status: 1,
        sortType: 3
      }).then(({ data }) => {
        this.festivalSaleList = data.list
        this.titleStatus = this.festivalSaleList.length === 0 ? 0 : this.festivalSaleList[0].titleStatus
        if (data.list && data.list.length) {
          data.list.forEach((item, i) => {
            this.getFestivalDiscountProductList(item.discountId, i)
          })
        }
      })
    },

    // 秒杀产品
    getDiscountProductList(id) {
      API.getDiscountProductList({
        pageNumber: 1,
        pageSize: 5,
        discountId: id,
        type: 1 // 1-限时促销 2-折扣活动(默认1)
        // sortType: 1, // 1-降序（默认），2-升序
        // sortName: 1 // 1-上架时间、2-售价、3-销售数量、4-库存
      }).then(({ data }) => {
        this.saleProductList = data.list
      })
    },

    // 专辑首页展示
    getAlbumModuleIndexList() {
      API.getAlbumModuleIndexList().then(res => {
        this.albumIndexList = res.data.filter(item => item.moduleList.length !== 0)
        this.albumIndexListLoop = JSON.parse(JSON.stringify(this.albumIndexList))
        this.albumIndexListLoop.map((v) => {
          if (v.moduleList !== undefined) {
            let length = 6
            let len = v.moduleList.length % length
            if (len > 0) {
              v.moduleList = v.moduleList.concat(v.moduleList.slice(0, length - len)) // 后面追加的数据，保证是 n 组数据，没有多、少数据
            }
            v.moduleList = this.arrayTo2array(v.moduleList, length)
          }
        })
      })
    },

    arrayTo2array(array, n) {
      let len = array.length
      let num = len % n === 0 ? len / n : Math.floor(len / n + 1)
      let res = []

      for (let i = 0; i < num; i++) {
        let temp = array.slice(i * n, i * n + n)
        res.push(temp)
      }
      return res
    },

    // 首页品类
    getDynamicCategroy() {
      API.getDynamicCategroy().then(({ data }) => {
        this.clsssColumn = data
      })
    },
    // getAlbumModuleShow() {
    //   API.getAlbumModuleShow().then(({ data }) => {
    //     this.clsssColumn = data
    //   })
    // },

    // 猜你喜欢
    getIndexUserRecs() {
      this.listLoading = true
      // API.getIndexUserRecs(this.likeParam).then(({ data }) => {
      let data = {
        'pageSize': 100,
        'pageNumber': 1,
        'materialArray': [],
        'minPrice': 0,
        'maxPrice': 200,
        'sortType': 'desc',
        'sortName': 1,
        'supplierLevels': []
      }
      API.getOpenNewInProductList(data).then(({ data }) => {
        const list = data.list || []
        if (!list || !list.length) {
          this.showMore = false
          return
        }
        this.likeProductList = data.pageNumber === 1 ? list.slice(0, 25) : [...this.likeProductList, ...list].slice(0, 25)
        this.total = data.total
      }).finally(() => {
        this.listLoading = false
      })
    },
    // 更多喜欢
    handleMore() {
      // if (!this.userId) {
      //   this.$router.push('/login')
      //   return
      // }
      if (!this.showMore) return
      ++this.likeParam.pageNumber
      this.getIndexUserRecs()
    },

    scroll() {
      if (this.isPC) {
        return
      }
      let scrollTop = document.documentElement.scrollTop || document.body.scrollTop
      let windowHeight = document.documentElement.clientHeight || document.body.clientHeight
      let scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight
      if (scrollTop + windowHeight - scrollHeight > -300 && !this.listLoading) {
        this.handleMore()
      }
    },

    // 搜索
    searchHandle(searchText) {
      let url = '/product-list'
      if (searchText) url += `?search=${searchText}`
      location.href = url
    },

    jump(path, type, value) {
      this.$record({
        eventType: 'click',
        eventId: `${this.$route.meta.pageId}_${type}_click`
      })
      this.$router.push(path)
    },

    jumpDiscount(t) {
      this.$router.push({ path: '/mall/discount', query: { discountId: t.discountId, type: t.type }})
    },

    jumpFlashSale() {
      this.$record({
        eventType: 'click',
        eventId: `${this.$route.meta.pageId}_flashSale_click`,
        value: JSON.stringify({ discountId: this.saleProductList.length && this.saleProductList[0].discountId, type: 'activity' })
      })
      this.$router.push({ path: '/mall/flash-sale', query: { discountId: this.saleProductList.length && this.saleProductList[0].discountId }})
    },

    jumpFestivalSale(item) {
      this.$record({
        eventType: 'click',
        eventId: `${this.$route.meta.pageId}_festivity_click`,
        value: JSON.stringify({ discountId: this.festivalSaleList.length && item.discountId, type: 'activity' })
      })
      this.$router.push({
        path: '/mall/festival-collection',
        query: {
          discountId: this.festivalSaleList.length && item.discountId
        }
      })
    },

    jumpAlbum(item) {
      location.href = `/album/${item.moduleUrl}`
      // this.$router.push({
      //   path: '/mall/album',
      //   query: {
      //     keywords: item.moduleUrl
      //   }
      // })
    },

    toggleDescription() {
    // 在这里编写展开文字描述的逻辑
    // 可以使用一个 data 变量来控制文字描述的展开与收起
      this.isExpanded = !this.isExpanded
    }
  }
}
</script>

<style lang="scss" scoped>
.m-t-3 {
  margin-top: 40px;
}
a {
  text-decoration: none;
  color: #000;
}
.index {
  flex-direction: column;
  padding: 24px 0 30px;
  padding-bottom: 50px;

  /deep/ .wsp {
    font-size: 16px;
    font-weight: 600;
  }
  .banner-contents {
    height: 376px;
  }

  .main {
    width: 100%;
    max-width: 1400px;
    min-width: 1000px;
    border-radius: 12px;
  }

  .contents1 {
    width: 246px;
    height: 376px;
    background-color: #fff;
    border-radius: 4px;
  }

  .banner {
    width: 876px;
    height: 100%;
    margin: 0 16px;

    /deep/ .el-carousel__item {
      border-radius: 4px;
    }

    .banner-box {
      img {
        display: block;
        height: 376px;
        object-fit: cover;
        // border-radius: 12px;
      }
    }
  }

  .contents2 {
    flex-shrink: 0;
    width: 260px;
    height: 100%;
    background-color: #fff;
    border-radius: 12px;
    flex-direction: column;

    .user {
      height: 100%;
      padding-top: 16px;

      .item {
        height: 44px;
        padding-left: 18px;

        i {
          margin-right: 8px;
        }
        .icon-Frame_2 {
          font-weight: bold;
          margin-left: 6px;
        }
      }

      .btn {
        width: 222px;
        height: 40px;
        margin: 0 auto;
        background-color: #99c41c;
        border-radius: 36px;
        color: #fff;
        margin-top: 16px;
      }

      .title {
        font-size: 18px;
        font-weight: 600;
        line-height: 40px;
        padding: 8px 6px 8px 25px;
      }

      .my {
        padding-left: 24px;
        height: 56px;
        border-bottom: 0.5px solid #f8f8f8;

        i {
          margin-right: 17px;
        }
      }
    }

    .freight {
      height: 66px;
      border-radius: 0 0 12px 12px;
      font-size: 14px;
      font-weight: 400;
      color: #f79e1b;
      border-top: 1px solid #e3e7ec;

      i {
        font-size: 22px;
        margin-right: 6px;
      }
    }
  }

  .cooperation {
    height: 48px;
    background-color: #fff;
    margin-top: 6px;
    box-sizing: border-box;
    border-radius: 12px;
    overflow: hidden;

    .text {
      font-size: 18px;
      flex-shrink: 0;
      margin-right: 20px;
    }

    .store {
      margin-left: 3%;

      img {
        width: 130px;
        height: 26px;
        margin-right: 10px;
      }
    }
  }

  .discount {
    .item {
      background-color: #fff;
      border-radius: 12px;
      flex-direction: column;
      height: 130px;
      width: 31.5%;
      box-sizing: border-box;
      padding: 0 20px;
      margin-right: 3%;

      .rate {
        font-size: 50px;
        font-weight: 600;
      }

      .unit {
        width: 70px;
        height: 30px;
        margin-left: 10px;
        background-color: #000;
        font-size: 20px;
        color: #fff;
      }

      .describe {
        margin-top: 3px;
        font-size: 20px;
        word-break: break-all;
      }
    }
    .item:nth-child(3) {
      margin-right: 0;
    }
  }

  .flash-sale {
    background-color: #fff;
    position: relative;
    padding: 16px;
    border-radius: 4px;

    .head {
      height: 32px;
      margin-bottom: 12px;

      .title {
        font-size: 24px;
        font-weight: 600;
        color: #303133;
      }
    }
  }

  .special-column {
    flex-wrap: wrap;

    > a,
    > div {
      display: block;
      width: 49.4%;
    }

    .img {
      flex-shrink: 0;
      margin-left: 10px;
      width: 120px;
      height: 40px;
      margin-top: -30px;
    }
  }

  .clsss-column {
    flex-wrap: wrap;

    > div {
      width: 32.3%;
      margin-bottom: 20px;
    }
  }

  .like {
    /deep/ .el-loading-mask {
      z-index: 900;
      background-color: rgba(245, 247, 247, 0.9);
    }

    .title {
      font-size: 30px;
      font-weight: 600;
    }

    .list {
      margin-top: 12px;
      flex-wrap: wrap;

      > div {
        width: 19.1%;
        padding-bottom: 20px;
      }
    }

    .more {
      width: 152px;
      height: 42px;
      border-radius: 42px;
      border: 1px solid #cdd4dd;
      font-size: 16px;
      margin: 0 auto;
      background-color: #fff;

      display: flex;

      /deep/ span {
        display: flex;
        align-items: center;
        justify-content: center;
      }

      i {
        color: #8b93a3;
        margin-left: 10px;
      }
    }
  }

  .special-column-left {
    height: 116px;
    background-image: url('https://img.kakaclo.com/web-img/new_index/customization.png');
    margin-top: 0;
  }
  .special-column-left:hover {
    box-shadow: 0px 10px 8px -1px rgba(0,0,0,0.05), 0px 24px 16px 2px rgba(0,0,0,0.01), 0px 30px 6px -5px rgba(0,0,0,0.01);
    margin-top: -4px;
  }

  .special-column-right {
    height: 116px;
    background-image: url('https://img.kakaclo.com/web-img/new_index/fashion-trends.png');
    margin-top: 0;
  }
  .special-column-right:hover {
    box-shadow: 0px 10px 8px -1px rgba(0,0,0,0.05), 0px 24px 16px 2px rgba(0,0,0,0.01), 0px 30px 6px -5px rgba(0,0,0,0.01);
    margin-top: -4px;
  }

  .special-column-left, .special-column-right  {
    .title {
      font-size: 24px;
      font-weight: 600;
      color: #303133;
      padding: 16px;
    }
    .subhead {
      font-size: 13px;
      font-weight: 400;
      color: #909399;
      line-height: 20px;
      padding-left: 16px;
    }
  }
  .new-flash-sale {
    width: 214.66px;
    position: relative;
    background: url('https://img.kakaclo.com/web-img/new_index/flash-sale.png');
    text-align: center;
    color: #FB5053;
    font-weight: bold;
    font-family: Poppins, Poppins;
    border-radius: 4px;
    .flash-sale-name {
      padding: 70px 0 12px;
    }
    .sale-view-more {
      position: absolute;
      bottom: 48px;
      left: 50%;
      margin-left: -50px;
      a {
        border: 1px solid #FB5053;
        color: #FB5053;
        font-weight: normal;
        display: inline-block;
        width: 100px;
        height: 32px;
        line-height: 32px;
        border-radius: 2px;
        cursor: pointer;
      }
    }
  }
  .view-more {
    font-size: 14px;
    line-height: 24px;
    color: #909399;
  }
  .view-more:hover {
    color: #9AC331;
  }
}
</style>

<style lang="scss" scoped>
.mobile-index {
  background-color: #F5F7F7;
  padding: 0.2rem 0.3rem;

  /deep/ .wsp {
    font-size: 14px;
    font-weight: 500;
  }
  .login-box {
    padding: 0.4rem 0.46rem;

    .text {
      text-align: center;
      width: 4.6rem;
      margin: 0 auto;
      font-size: 0.28rem;
      line-height: 0.4rem;
    }

    .btn {
      margin-top: 0.4rem;
      > div {
        width: 2.6rem;
        height: 0.84rem;
        border: 0.5px solid #b6b6b6;
        border-radius: 0.16rem;
        font-size: 0.32rem;
      }
      .login {
        background: #99c41c;
        color: #fff;
      }
    }
  }

  .banner {
    padding: 0.2rem 0;

    .banner-box {
      width: 100%;
      height: 2.46rem;

      img {
        width: 100%;
        height: 100%;
        border-radius: 4px;
        object-fit: cover;
      }
    }
  }

  .discount {
    margin-bottom: 0.6rem;

    .item {
      min-height: 1.08rem;
      max-height: 1.4rem;
      width: 32%;
      flex-direction: column;
      box-sizing: border-box;
      margin-right: 2%;

      .rate {
        font-size: 0.4rem;
        font-weight: 600;
      }

      .unit {
        width: 0.48rem;
        height: 0.26rem;
        margin-left: 0.04rem;
        background-color: #000;
        font-size: 0.18rem;
        color: #fff;
      }

      .describe {
        margin-top: 3px;
        font-size: 0.18rem;
        word-break: break-all;
      }
    }
    .item:nth-child(3) {
      margin-right: 0;
    }
  }

  .flash-sale {
    position: relative;
    margin-top: 20px;
    background: #fff;
    padding: 16px;
    border-radius: 4px;
    .head {
      height: 0.48rem;
      margin-bottom: 0.24rem;

      .title {
        font-size: 20px;
        font-weight: 600;
        color: #303133;
      }
    }

    /deep/ .time-comp {
      .block {
        width: 0.4rem;
        height: 0.48rem;
        font-size: 0.3rem;
        line-height: 0.48rem;
      }
    }

    .sale-list {
      height: 100%;
      overflow: auto;

      .product {
        width: 2rem;
        margin-right: 0.14rem;
      }
      .product:last-child {
        margin-right: 0;
      }
    }

    ::-webkit-scrollbar {
      width: 0;
      height: 0;
    }
  }

  /deep/ .title-price {
    margin-top: 4px;
  }
  .special-column-left {
    height: 108px;
    background-image: url('https://img.kakaclo.com/web-img/new_index/mobile-customization.png');
    background-size: 100%;
    margin: 16px 0 8px 0;
    border-radius: 4px;
    background-repeat: no-repeat;
  }

  .special-column-right {
    height: 108px;
    background-image: url('https://img.kakaclo.com/web-img/new_index/mobile-fashion-trends.png');
    background-size: 100%;
    margin-bottom: 40px;
    border-radius: 4px;
    background-repeat: no-repeat;
  }

  .special-column-left, .special-column-right  {
    .title {
      font-size: 20px;
      line-height: 28px;
      font-weight: 600;
      color: #303133;
      padding: 16px 16px 12px 16px;
    }
    .subhead {
      font-size: 12px;
      font-weight: 400;
      color: #909399;
      line-height: 18px;
      padding-left: 16px;
    }
  }
  .new-flash-sale {
    width: 32%;
    position: relative;
    background: url('https://img.kakaclo.com/web-img/new_index/flash-sale.png');
    text-align: center;
    color: #FB5053;
    font-weight: bold;
    font-family: Poppins, Poppins;
    background-size: 100%;
    border-radius: 4px;
    .flash-sale-name {
      padding-top: 30px;
    }
    .sale-view-more {
      position: absolute;
      bottom: 16px;
      left: 50%;
      margin-left: -44px;
      a {
        border: 1px solid #FB5053;
        color: #FB5053;
        font-weight: normal;
        display: inline-block;
        width: 88px;
        height: 32px;
        line-height: 32px;
        border-radius: 2px;
        cursor: pointer;
        font-size: 12px;
      }
    }
  }
  .view-more {
    font-size: 12px;
    line-height: 24px;
    color: #909399;
  }

  .clsss-column {
    height: 100%;
    margin-top: 16px;

    /deep/.class-column {
      padding: 0.24rem 0.28rem;

      .title {
        // font-size: 0.32rem;
        font-size: 16px;
        .right {
          // font-size: 0.28rem;
          font-size: 12px;
        }
      }
      .column-list {
        margin-top: 0.2rem;
      }
    }

    /deep/.swiper-pagination {
      .swiper-pagination-bullet-active {
        background: #99c41c;
      }
    }
  }

  .like {
    margin-top: 0.6rem;

    /deep/ .el-loading-mask {
      z-index: 900;
      background-color: rgba(245, 247, 247, 0.9);
    }

    .title {
      font-size: 0.32rem;
      font-weight: 600;
    }

    .list {
      margin-top: 20px;
      flex-wrap: wrap;

      > div {
        width: 48%;
      }
    }
  }

  .login-top {
    width: 100vw;
    height: 1rem;
    box-sizing: border-box;
    position: relative;
    margin-left: -0.3rem;
    background: rgba(13, 16, 22, 0.79);
    color: #fff;
    margin-bottom: 0.2rem;
    padding: 0 0.32rem;
    .login-close {
      width: 0.4rem;
      height: 0.4rem;
      background: #000;
      border-radius: 50%;
      margin-left: 0.24rem;
    }
  }

}
.description {
  margin-top: 20px; /* 增加文字段落和按钮的上边距 */
  display: flex;
  position: relative;
  flex-direction: column; /* 将按钮和文本放在垂直方向 */
  }

  .description-text {
    word-wrap:break-word;
    margin-top: 10px; /* 增加文字段落和按钮的上边距 */
    margin-bottom: 20px; /* 增加文字段落和按钮的下边距 */
    overflow: hidden;
    padding:  0 20px 0 0;
    box-sizing: border-box;
    line-height: 1.5;
  }

  .description > div.collapsed {
    max-height: 500px; /* 控制默认最大高度，可根据需求修改 */
    overflow: hidden;
  }
  .toggle-button {
    align-self: flex-end;
    color: #99c41c;
    padding: 4px 8px;
    cursor: pointer;
    display: block;
    z-index: 1;
    position: absolute;
    font-size: 21px;
  }

  .toggle-title {
    color: #0d0e0d;
    padding: 4px 20px 4px 0px;
    cursor: pointer;
    z-index: 1;
  }
</style>
